import { useEffect, type ReactElement, type ReactNode } from "react"
import { RootState } from "src/app/store"
import { Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { AppDispatch } from "src/app/store"

export interface ProtectedRouteProps {
        children?: ReactNode
}

export default function ProtectedRoute(props: ProtectedRouteProps): ReactElement {
        const { isAuthenticated } = useSelector((state: RootState) => state.auth);
        const dispatch = useDispatch<AppDispatch>();

        useEffect(() => {
                const token = localStorage.getItem('authToken');
                if (token === null) {
                        dispatch({ type: "RESET" });
                }
        }, [isAuthenticated])

        return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}
